import { useState, useCallback } from 'react';
import { createMessage, getErrorMessage } from './helpers';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useChatMessages = (sessionId) => {
  const [messages, setMessages] = useState([
    createMessage("Hello! I'm the DentiFlow AI Assistant. How can I help you today?", 'bot')
  ]);
  const [isTyping, setIsTyping] = useState(false);

  // Dependencies: sessionId and isTyping are reactive values that should trigger callback recreation
  // API_URL, createMessage, getErrorMessage are stable imports/constants and don't need to be in deps
  const sendMessage = useCallback(async (textToSend) => {
    if (!textToSend || typeof textToSend !== 'string' || !textToSend.trim() || isTyping) {
      return;
    }

    // Add user message
    const userMessage = createMessage(textToSend, 'user');
    setMessages(prev => [...prev, userMessage]);
    setIsTyping(true);
    
    try {
      const response = await fetch(`${API_URL}/api/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: textToSend,
          session_id: sessionId
        })
      });

      if (!response.ok) {
        throw new Error('Failed to get response from AI');
      }

      const data = await response.json();
      setIsTyping(false);
      
      const botMessage = createMessage(data.response, 'bot', 1);
      setMessages(prev => [...prev, botMessage]);

    } catch (error) {
      setIsTyping(false);
      
      const errorMessage = createMessage(getErrorMessage(), 'bot', 2);
      setMessages(prev => [...prev, errorMessage]);
    }
  }, [sessionId, isTyping]);

  return { messages, isTyping, sendMessage };
};
